// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { addressProps } from "@store/Themes/common/props/address";
import { orderProps } from "@store/Themes/common/props/order";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
/* Starter Custom Code */

interface OwnProps {
    billTo: BillToModel;
    onEdit: () => void;
    extendedStyles?: BillingAddressInfoDisplayStyles;
}

export interface BillingAddressInfoDisplayStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    heading?: TypographyPresentationProps;
    editLink?: LinkPresentationProps;
    addressGridItem?: GridItemProps;
    address?: AddressInfoDisplayStyles;
}

export const billingAddressInfoDisplayStyles: BillingAddressInfoDisplayStyles = {
    heading: orderProps.subtitle,
    address: {
        wrapper: addressProps.wrapper,
    },
    editLink: addressProps.linkEdit,
};

const BillingAddressInfoDisplay = ({ billTo, onEdit, extendedStyles }: OwnProps) => {
    const styles = useMergeProps(billingAddressInfoDisplayStyles, extendedStyles); // Starter Custom Code
    return (
        /* Starter Custom Code */
        <StyledWrapper>
            <Typography {...styles.heading}>{translate("Billing Address")}</Typography>
            <AddressInfoDisplay
                {...billTo}
                state={billTo.state ? billTo.state.abbreviation : undefined}
                country={billTo.country ? billTo.country.abbreviation : undefined}
                extendedStyles={styles.address}
            />
            {/* <Link {...styles.editLink} onClick={onEdit} data-test-selector="checkoutReviewAndSubmit_changeBilling">
                {translate("Edit")}
                <VisuallyHidden>{translate("Billing Address")}</VisuallyHidden>
            </Link> */}
        </StyledWrapper>
        /* Starter Custom Code */
    );
};

export default BillingAddressInfoDisplay;
